import styled from "@emotion/styled";

export const SmartCardSection = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: ${({ theme }) => theme.spacing.md};
  padding-left: ${({ theme }) => theme.spacing.smd};
  padding-right: ${({ theme }) => theme.spacing.smd};
  padding-bottom: 0;
`;

export const NoteList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xxs};
`;

export const SeeMoreRow = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  height: 24px;
  gap: 8px;
  padding: 4px 0;
  align-self: flex-start;
  border: none;
  background: transparent;
  border-radius: 4px;
  cursor: pointer;
  transition: color 0.08s ease;
  margin-left: 14px;
  margin-bottom: 2px;

  color: ${({ theme }) => theme.colors.text.secondary};

  &:hover {
    color: ${({ theme }) => theme.colors.text.primary};
  }
`;
